import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getSettingFaireDirectWidgetInstallationSelfServe } from "@faire/help-center-utils/settings/getSettingFaireDirectWidgetInstallationSelfServe";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Link } from "@faire/web/slate/icons/foundation/Link";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { FaireDirectWidgetIA } from "../instantAnswers/faireDirect-faireDirectWidget";
export var useFaireDirectBrandNodes = function useFaireDirectBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  var commonFields = {
    id: "FaireDirect",
    label: strictLocalize({
      id: "+Rdcct",
      defaultMessage: [{
        "type": 0,
        "value": "Faire Direct"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Link, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    level: 1,
    sidebarTitle: strictLocalize({
      id: "aaCorN",
      defaultMessage: [{
        "type": 0,
        "value": "Faire Direct issue"
      }]
    })
  };
  if (getSettingFaireDirectWidgetInstallationSelfServe()) {
    return {
      FaireDirect: _objectSpread(_objectSpread({}, commonFields), {}, {
        children: ["FaireDirectWidgetChat", "OtherFaireDirect"]
      }),
      FaireDirectWidgetChat: {
        id: "FaireDirectWidgetChat",
        label: strictLocalize({
          id: "5lpl6m",
          defaultMessage: [{
            "type": 0,
            "value": "Faire Direct widget"
          }]
        }),
        articles: [articles.FaireDirect.WIDGET_GENERAL, articles.FaireDirect.WIDGET_SHOPIFY, articles.FaireDirect.WIDGET_WOOCOMMERCE, articles.FaireDirect.WIDGET_PRESTASHOP],
        instantAnswer: FaireDirectWidgetIA(strictLocalize),
        level: 2
      },
      OtherFaireDirect: {
        id: "OtherFaireDirect",
        label: OTHER_NODES_LABEL(strictLocalize),
        articles: [articles.FaireDirect.ORDER_COMMISSION, articles.FaireDirect.FAIRE_DIRECT, articles.FaireDirect.FD_ELIGIBLE, articles.FaireDirect.FD_LINK],
        level: 2
      }
    };
  }
  return {
    FaireDirect: _objectSpread(_objectSpread({}, commonFields), {}, {
      articles: [articles.FaireDirect.ORDER_COMMISSION, articles.FaireDirect.FAIRE_DIRECT, articles.FaireDirect.FD_ELIGIBLE, articles.FaireDirect.FD_LINK]
    })
  };
};